import { gql } from '@utils/gpl-dedup';
import { onCallAssignmentFragment } from '@graphql/onCallAssignments/fragments';

export const currentOnCallAssignment = gql`
  query {
    currentOnCallAssignment {
      ...onCallAssignmentFragment
    }
  }
  ${onCallAssignmentFragment}
`;
